import React from 'react'
const RHSCard = (props) => {
  return <div>{props.children}</div>
}

RHSCard.propTypes = {}

export default RHSCard
